import { render, staticRenderFns } from "./aiAdminUsers.vue?vue&type=template&id=2e6b9dab&scoped=true"
import script from "./aiAdminUsers.vue?vue&type=script&lang=js"
export * from "./aiAdminUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b9dab",
  null
  
)

export default component.exports